import { IJOIST_INPUT_TYPE } from '../../../../utils/constants'
import { isMemberTypeIJoist } from '../fns'

const IJOIST_THICKNESS = {
  '1 1/8': 1.125,
  '1 1/4': 1.25,
  '1 5/16': 1.313,
  '1 3/8': 1.375,
  '1 1/2': 1.5,
}

const IJOIST_MATERIAL_ENUM = {
  LEGACY_DF: 11,
  LEGACY_SPF: 19,
  DF: 44,
  SPF: 45,
  DF_1125: 40,
  DF_1250: 41,
  DF_1313: 42,
  DF_1375: 43,
}

const MANUAL_DF_MATERIAL = {
  [IJOIST_THICKNESS['1 1/8']]: IJOIST_MATERIAL_ENUM.DF_1125,
  [IJOIST_THICKNESS['1 1/4']]: IJOIST_MATERIAL_ENUM.DF_1250,
  [IJOIST_THICKNESS['1 5/16']]: IJOIST_MATERIAL_ENUM.DF_1313,
  [IJOIST_THICKNESS['1 3/8']]: IJOIST_MATERIAL_ENUM.DF_1375,
  [IJOIST_THICKNESS['1 1/2']]: IJOIST_MATERIAL_ENUM.DF,
}

const MATERIAL_LEGACY_TO_NEW = {
  [IJOIST_MATERIAL_ENUM.LEGACY_DF]: IJOIST_MATERIAL_ENUM.DF,
  [IJOIST_MATERIAL_ENUM.LEGACY_SPF]: IJOIST_MATERIAL_ENUM.SPF,
}

const INPUT_TYPE_LEGACY_TO_NEW = {
  [IJOIST_INPUT_TYPE.LEGACY_MANUALLY]: IJOIST_INPUT_TYPE.MANUALLY,
  [IJOIST_INPUT_TYPE.LEGACY_MANUFACTURER]: IJOIST_INPUT_TYPE.MANUFACTURER, // fixed typo
}

export const ijoistUtils = {
  isSPFMaterial: (material) => material === IJOIST_MATERIAL_ENUM.SPF,

  isManufacturerInput: (inputType) =>
    inputType === IJOIST_INPUT_TYPE.LEGACY_MANUFACTURER ||
    inputType === IJOIST_INPUT_TYPE.MANUFACTURER,

  convertManualMaterial: (data) => {
    const { ijoistInputType, material, thickness } = data
    return ijoistUtils.isManufacturerInput(ijoistInputType) || ijoistUtils.isSPFMaterial(material)
      ? material
      : MANUAL_DF_MATERIAL[thickness] || IJOIST_MATERIAL_ENUM.DF
  },

  convertLegacyInputType: (tabNumber) =>
    INPUT_TYPE_LEGACY_TO_NEW[tabNumber] || IJOIST_INPUT_TYPE.MANUALLY,

  convertLegacyMaterial: (type, material) =>
    isMemberTypeIJoist(type) ? MATERIAL_LEGACY_TO_NEW[material] || material : material,
}
